import * as React from 'react';

import Tab, { Tabs } from '@/components/elements/Button/TabButton';
import { getBetMethodName } from '@/lib/race';
import { BetMethod } from '@/modelTypes';

interface BetMethodSelectorProps {
  betMethod: BetMethod;
  isModifyingDisabled: (
    key: 'betMethod' | 'betType' | 'wheelAxis',
    arg: string,
  ) => boolean;
  setBetMethod: React.Dispatch<React.SetStateAction<BetMethod>>;
}

const BetMethodSelector: React.FC<BetMethodSelectorProps> = React.memo(
  ({ betMethod, isModifyingDisabled, setBetMethod }) => {
    return (
      <Tabs>
        {(Object.values(BetMethod) as BetMethod[]).map(bm => (
          <Tab
            key={bm}
            active={betMethod === bm}
            disabled={isModifyingDisabled('betMethod', bm)}
            onClick={() => setBetMethod(bm)}
          >
            {getBetMethodName(bm)}
          </Tab>
        ))}
      </Tabs>
    );
  },
);

export default BetMethodSelector;
